import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { AcquiringType, PaymentType } from 'types';

type PaymentReducerType = {
  acquiring: null | AcquiringType;
  paymentData: null | PaymentType;
  amount: string;
  fullAmount: string | number;
  isPayment: boolean;
  isInvoice: boolean;
  isOnlyBankCard: boolean;
  isValidForCheck: boolean;
  step: number;
  formKey: string;
  comment: string;
};

const initialState: PaymentReducerType = {
  paymentData: null,
  isPayment: false,
  isInvoice: false,
  isOnlyBankCard: false,
  isValidForCheck: true,
  acquiring: null,
  amount: '',
  fullAmount: '',
  step: 1,
  formKey: '',
  comment: '',
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setAcquiring: (state, { payload }: PayloadAction<AcquiringType | null>) => {
      state.acquiring = payload;
    },
    setPaymentData: (state, { payload }: PayloadAction<PaymentType | null>) => {
      state.paymentData = state.paymentData ? { ...state.paymentData, ...payload } : payload;
    },
    setIsValidForCheck: (state, { payload }: PayloadAction<boolean>) => {
      state.isValidForCheck = payload;
    },
    setAmount: (state, { payload }: PayloadAction<string>) => {
      state.amount = payload;
    },
    setIsPayment: (state, { payload }: PayloadAction<boolean>) => {
      state.isPayment = payload;
    },
    setIsInvoice: (state, { payload }: PayloadAction<boolean>) => {
      state.isInvoice = payload;
    },
    setFullAmount: (state, { payload }: PayloadAction<string>) => {
      state.fullAmount = payload;
    },
    setStep: (state, { payload }: PayloadAction<number>) => {
      state.step = payload;
    },
    setFormKey: (state, { payload }: PayloadAction<string>) => {
      state.formKey = payload;
    },
    setComment: (state, { payload }: PayloadAction<string>) => {
      state.comment = payload;
    },
    setIsOnlyBankCard: (state, { payload }: PayloadAction<boolean>) => {
      state.isOnlyBankCard = payload;
    },
  },
});

export const {
  setAcquiring,
  setPaymentData,
  setAmount,
  setIsPayment,
  setIsInvoice,
  setFullAmount,
  setStep,
  setFormKey,
  setComment,
  setIsOnlyBankCard,
  setIsValidForCheck,
} = paymentSlice.actions;

export default paymentSlice.reducer;
